import React, { useContext } from 'react';
import Text from 'components/shared/Text';
import styles from './style.module.css';
import { useHistory } from 'react-router-dom';
import MobileContext from 'context/MobileContext';

const Advertisement = ({ mvpTrainingData }) => {
  const history = useHistory();
  const isMobile = useContext(MobileContext);
  const apiData = mvpTrainingData?.fitsessionData;
  const buttonName = 'BOOK NOW >>';

  const handleNavigate = data => {
    const navigationUrl = {
      url: data,
    };
    history.push({ pathname: '/mvpTraining', state: navigationUrl });
  };

  return (
    <div className={styles.body}>
      <Text className={styles.heading}>
        Find the best path to reach {isMobile ? <br /> : null} your goals.
      </Text>
      <div className={styles.imgContainer}>
        {apiData?.map((item, index) => {
          return (
            <div
              style={{
                backgroundImage: `url(${item?.imageURL})`,
                marginLeft: isMobile ? '0' : index !== 0 ? '10px' : '0',
                marginBottom: isMobile ? '20px' : '0',
              }}
              className={styles.backImgContainer}
              key={index}
            >
              <div className={styles.text}>
                <b className={styles.contentTitle}>
                  {item?.title.includes('COMPLIMENTARY') && isMobile ? (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: item?.title.replace(
                          'COMPLIMENTARY',
                          'COMPLIMENTARY<br/>'
                        ),
                      }}
                    />
                  ) : (
                    item?.title
                  )}
                </b>
                <p className={styles.content}>{item?.subTitle}</p>
              </div>
              <button
                onClick={() => handleNavigate(item?.navigationURL)}
                className={styles.bookNowButton}
              >
                {buttonName}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Advertisement;
